import React from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';

const AuthLayout = ({ children, title, subtitle }) => {
  return (
    <div className="auth-page-wrapper d-flex justify-content-center align-items-center min-vh-100 bg-light">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={4}>
            <Card className="shadow-lg border-0 rounded-4 mt-4">
              <CardBody className="p-4">
                <div className="text-center mt-2">
                  <h4 className="text-primary font-weight-bold">{title}</h4>
                  <p className="text-muted">{subtitle}</p>
                </div>
                <div className="p-2 mt-4">
                  {children}
                </div>
              </CardBody>
            </Card>
            <div className="mt-4 text-center">
              <p className="text-muted">© {new Date().getFullYear()} Series Dashboard.</p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AuthLayout;
